import { render, staticRenderFns } from "./ClientePerfil.vue?vue&type=template&id=5c060c51&scoped=true"
import script from "./ClientePerfil.vue?vue&type=script&lang=ts"
export * from "./ClientePerfil.vue?vue&type=script&lang=ts"
import style0 from "./ClientePerfil.vue?vue&type=style&index=0&id=5c060c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c060c51",
  null
  
)

export default component.exports